import { render, staticRenderFns } from "./PickerYear.vue?vue&type=template&id=008b7b02&"
import script from "./PickerYear.vue?vue&type=script&lang=js&"
export * from "./PickerYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008b7b02')) {
      api.createRecord('008b7b02', component.options)
    } else {
      api.reload('008b7b02', component.options)
    }
    module.hot.accept("./PickerYear.vue?vue&type=template&id=008b7b02&", function () {
      api.rerender('008b7b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Vendor/vuejs-datepicker/src/components/PickerYear.vue"
export default component.exports